export enum LocalStorage {
    USER = 'user',
    TOKEN = 'x-access-token'
}
